import React from 'react';
import { useTranslation } from 'react-i18next';
import useSiteConfig from '../../hooks/useSiteConfig';

/** Country-specific legal acknowledgment for standard raffles. Hidden when the country has none. */
export default function LotteryAcknowledgment({ precioTicket }) {
  const { t } = useTranslation();
  const config = useSiteConfig();
  const rule = config?.lotteryAck;
  const text = config?.site ? t(`raffle.lotteryAck.${config.site}`, { defaultValue: '' }) : '';

  if (!rule || !text) return null;

  return (
    <div className='space-y-1.5'>
      <label className='flex items-center gap-2 text-sm text-foreground'>
        <input
          type='checkbox'
          className='accent-primary'
          required={Number(precioTicket) > (Number(rule.minTicketPrice) || 0)}
        />
        {text}
      </label>
    </div>
  );
}
